const DIRECTIVE_NAME = 'ktTypeahead';

export default function Typeahead(
    $timeout
) {
    'ngInject';

    return {
        restrict: 'A',
        require: ['ngModel', 'uibTypeahead'],
        link: function($scope, $elem, $attrs, [ngModelCtrl]) {

            if (getAttributeValue('OpenDropdown')) {
                $timeout(() => openDropdown());
            }

            function getAttributeValue(attribute) {
                return $scope.$eval($attrs[`${DIRECTIVE_NAME}${attribute}`]);
            }

            function openDropdown() {
                $elem.focus();
                const value = ngModelCtrl.$viewValue;
                ngModelCtrl.$setViewValue(`${value},`);
            }
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/directives/typeahead/typeahead-directive.js